import { Component, Input } from '@angular/core';
import { IActionButton } from '../../models';

@Component({
  selector: 'bkui-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent {
  @Input() actions: IActionButton[] = [];
}
